export const collectClientFingerprint = () => {
  if (typeof window === "undefined" || typeof navigator === "undefined") {
    return {};
  }

  const nav = navigator;
  let webglRenderer = null;
  try {
    const canvas = document.createElement("canvas");
    const gl = canvas.getContext("webgl") || canvas.getContext("experimental-webgl");
    const debug = gl?.getExtension?.("WEBGL_debug_renderer_info");
    if (gl && debug) {
      webglRenderer = gl.getParameter(debug.UNMASKED_RENDERER_WEBGL);
    }
  } catch {
    webglRenderer = null;
  }

  let timezone = null;
  try {
    timezone = Intl.DateTimeFormat().resolvedOptions().timeZone || null;
  } catch {
    timezone = null;
  }

  return {
    webdriver: Boolean(nav.webdriver),
    playwright_hint: Boolean(
      window.__playwright ||
        window.__pwInitScripts ||
        window.__PW_inspect ||
        document.documentElement?.getAttribute?.("data-playwright") != null
    ),
    automation_hint: Boolean(
      window.callPhantom ||
        window._phantom ||
        window.__nightmare ||
        window.domAutomation ||
        window.domAutomationController
    ),
    user_agent: nav.userAgent || null,
    languages: Array.isArray(nav.languages) ? nav.languages.slice(0, 8) : [],
    platform: nav.platform || null,
    touch: Number(nav.maxTouchPoints || 0) > 0,
    timezone,
    hardware_concurrency:
      typeof nav.hardwareConcurrency === "number" ? nav.hardwareConcurrency : null,
    device_memory: typeof nav.deviceMemory === "number" ? nav.deviceMemory : null,
    plugins_count:
      nav.plugins && typeof nav.plugins.length === "number" ? nav.plugins.length : null,
    webgl_renderer: webglRenderer ? String(webglRenderer).slice(0, 128) : null,
  };
};
